<template>
    <div class="TileDataElaadCombination">
        <div v-if="simpleView">
            <TileDataContent
                :fids="fids"
                :forecast-label="forecastLabel"
                :dataset="dataset"
                :data-by-id="dataById"
            >
                <template #content-header>
                    <TileDataContentHeader>
                        <template #second-column>
                            <b> {{ $t('components.map.tiles.ElaadForecast.totalChargingPoints') }} </b>
                        </template>
                    </TileDataContentHeader>
                </template>

                <template #sub-title>
                    <p>
                        <span class="currentView"> {{ $t('components.map.tiles.ElaadForecast.simpleView') }} </span> |
                        <span
                            class="otherView"
                            @click="toggleView"
                        > {{ $t('components.map.tiles.ElaadForecast.toPlan') }} </span>
                    </p>
                </template>

                <template #sub-title2>
                    <p>
                        {{ $t('components.map.tiles.NeighborhoodData.elaadCombinatieM') }}
                    </p>
                </template>

                <template #content>
                    <TileDataContentRowTwoColumn>
                        <template #first-column>
                            {{ $t('components.map.tiles.ElaadForecast.prognose') }}
                        </template>
                        <template #second-column>
                            {{ formatNumber(totalLaadpunten()) }}
                        </template>
                    </TileDataContentRowTwoColumn>
                    <TileDataContentRowTwoColumn>
                        <template #first-column>--------------------</template>
                        <template #second-column>--------------------</template>
                    </TileDataContentRowTwoColumn>
                    <TileDataContentRowTwoColumn>
                        <template #first-column>
                            {{ $t('components.map.tiles.ElaadForecast.current') }}
                        </template>
                        <template #second-column>
                            <b-spinner
                                v-if="isChargingPointsLoadingForStatus(statusRealized)
                                    || isChargingPointsLoadingForStatus(statusInProgress)
                                    || isChargingPointsLoadingForStatus(statusDefinitive)"
                                small
                            />
                            <span v-else>
                                {{ formatNumber(currentChargingPoints()) }}
                            </span>
                        </template>
                    </TileDataContentRowTwoColumn>
                    <TileDataContentRowTwoColumn>
                        <template #first-column>--------------------</template>
                        <template #second-column>--------------------</template>
                    </TileDataContentRowTwoColumn>
                    <TileDataContentRowTwoColumn>
                        <template #first-column>
                            {{ $t('components.map.tiles.ElaadForecast.toPlan') }}
                        </template>
                        <template #second-column>
                            <b-spinner
                                v-if="isChargingPointsLoadingForStatus(statusRealized)
                                    || isChargingPointsLoadingForStatus(statusInProgress)
                                    || isChargingPointsLoadingForStatus(statusDefinitive)"
                                small
                            />
                            <span v-else>
                                {{ formatNumber(remainingChargingPoints()) }}
                            </span>
                        </template>
                    </TileDataContentRowTwoColumn>
                </template>

                <template #footer>
                    ID: {{ fids[0] }}
                </template>
            </TileDataContent>
        </div>

        <div v-else>
            <TileDataContent
                :fids="fids"
                :forecast-label="forecastLabel"
                :dataset="dataset"
                :data-by-id="dataById"
            >
                <template #content-header>
                    <TileDataContentHeader>
                        <template #second-column>

                        </template>
                    </TileDataContentHeader>
                </template>

                <template #sub-title>
                    <p>
                        <span
                            class="otherView"
                            @click="toggleView"
                        > {{ $t('components.map.tiles.ElaadForecast.simpleView') }} </span> |
                        <span class="currentView"> {{ $t('components.map.tiles.ElaadForecast.toPlan') }} </span>
                    </p>
                </template>

                <template #sub-title2>
                    <p>
                        {{ $t('components.map.tiles.NeighborhoodData.elaadCombinatieM') }}
                    </p>
                </template>

                <template #content>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column />
                        <template #second-column>
                            <b>{{ $t('components.map.tiles.ElaadForecast.prognose') }}</b>
                        </template>
                        <template #third-column>
                            <b>{{ $t('components.map.tiles.ElaadForecast.current') }}</b>
                        </template>
                        <template #fourth-column>
                            <b>{{ $t('components.map.tiles.ElaadForecast.toPlan') }}</b>
                        </template>
                    </TileDataContentRow>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column>
                            {{ $t('components.map.tiles.ElaadForecast.(semi)public') }}
                        </template>
                        <template #second-column>
                            {{ formatNumber(laadpuntenSemiPubliek()) }}
                        </template>
                        <template #third-column>—</template>
                        <template #fourth-column>—</template>
                    </TileDataContentRow>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column>
                            {{ $t('components.map.tiles.ElaadForecast.EbestelShort') }}
                        </template>
                        <template #second-column>
                            {{ formatNumber(laadpuntenBestelautos()) }}
                        </template>
                        <template #third-column>—</template>
                        <template #fourth-column>—</template>
                    </TileDataContentRow>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column>--------------------</template>
                        <template #second-column>--------------------</template>
                        <template #third-column>--------------------</template>
                        <template #fourth-column>--------------------</template>
                    </TileDataContentRow>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column>
                            {{ $t('groupLabels.realized') }}
                        </template>
                        <template #second-column>—</template>
                        <template #third-column>
                            <b-spinner
                                v-if="isChargingPointsLoadingForStatus(statusRealized)"
                                small
                            />
                            <span v-else-if="isChargingPointsEmptyForStatus(statusRealized)">
                                —
                            </span>
                            <span v-else>
                                {{ formatNumber(getChargingPointsCount({ status: statusRealized })) }}
                            </span>
                        </template>
                        <template #fourth-column>—</template>
                    </TileDataContentRow>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column>
                            {{ $t('groupLabels.in-progress') }}
                        </template>
                        <template #second-column>—</template>
                        <template #third-column>
                            <b-spinner
                                v-if="isChargingPointsLoadingForStatus(statusInProgress)"
                                small
                            />
                            <span v-else-if="isChargingPointsEmptyForStatus(statusInProgress)">
                                —
                            </span>
                            <span v-else>
                                {{ formatNumber(getChargingPointsCount({ status: statusInProgress })) }}
                            </span>
                        </template>
                        <template #fourth-column>—</template>
                    </TileDataContentRow>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column>
                            {{ $t('groupLabels.definitive') }}
                        </template>
                        <template #second-column>—</template>
                        <template #third-column>
                            <b-spinner
                                v-if="isChargingPointsLoadingForStatus(statusDefinitive)"
                                small
                            />
                            <span v-else-if="isChargingPointsEmptyForStatus(statusDefinitive)">
                                —
                            </span>
                            <span v-else>
                                {{ formatNumber(getChargingPointsCount({ status: statusDefinitive })) }}
                            </span>
                        </template>
                        <template #fourth-column>—</template>
                    </TileDataContentRow>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column>
                            {{ $t('groupLabels.suggestion') }}
                        </template>
                        <template #second-column>—</template>
                        <template #third-column>
                            <b-spinner
                                v-if="isChargingPointsLoadingForStatus(statusSuggestion)"
                                small
                            />
                            <span v-else-if="isChargingPointsEmptyForStatus(statusSuggestion)">
                                —
                            </span>
                            <span v-else>
                                {{ formatNumber(getChargingPointsCount({ status: statusSuggestion })) }}
                            </span>
                        </template>
                        <template #fourth-column>—</template>
                    </TileDataContentRow>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column>--------------------</template>
                        <template #second-column>--------------------</template>
                        <template #third-column>--------------------</template>
                        <template #fourth-column>--------------------</template>
                    </TileDataContentRow>
                    <TileDataContentRow :nr-of-columns="4">
                        <template #first-column>
                            {{ $t('components.map.tiles.ElaadForecast.total') }}
                        </template>
                        <template #second-column>
                            {{ formatNumber(totalLaadpunten()) }}
                        </template>
                        <template #third-column>
                            <b-spinner
                                v-if="isChargingPointsLoadingForStatus(statusRealized)
                                    || isChargingPointsLoadingForStatus(statusInProgress)
                                    || isChargingPointsLoadingForStatus(statusDefinitive)"
                                small
                            />
                            <span v-else>
                                {{ formatNumber(currentChargingPoints()) }}
                            </span>
                        </template>
                        <template #fourth-column>
                            <b-spinner
                                v-if="isChargingPointsLoadingForStatus(statusRealized)
                                    || isChargingPointsLoadingForStatus(statusInProgress)
                                    || isChargingPointsLoadingForStatus(statusDefinitive)"
                                small
                            />
                            <span v-else>
                                {{ formatNumber(remainingChargingPoints()) }}
                            </span>
                        </template>
                    </TileDataContentRow>
                </template>

                <template #footer>
                    ID: {{ fids[0] }}
                </template>
            </TileDataContent>
        </div>
    </div>
</template>

<script>
import TileDataContent from '@/components/map/tiles/TileDataContent'
import TiledataMixin from '@/mixins/map/tiledata-mixin'
import TileDataContentHeader from '@/components/map/tiles/TileDataContentHeader'
import TileDataContentRow from '@/components/map/tiles/TileDataContentRow'
import TileDataContentRowTwoColumn from '@/components/map/tiles/TileDataContentRowTwoColumn'
import { mapActions, mapGetters } from 'vuex'
import { getChargingpointByPolygon } from '@/../shared/API/chargingpoints'
import { buildPolygonPayloadCoordinates } from '@/helpers/geojson'

const STATUS_REALIZED = 'realized'
const STATUS_IN_PROGRESS = 'in-progress'
const STATUS_DEFINITIVE = 'definitive'
const STATUS_SUGGESTION = 'suggestion'

export default {
    name: 'TileDataElaadCombination',
    components: {
        TileDataContentRow,
        TileDataContentRowTwoColumn,
        TileDataContentHeader,
        TileDataContent,
    },
    mixins: [TiledataMixin],
    data() {
        return {
            simpleView: true,
            chargingPointsByFid: {},
            chargingPointsNotFoundByFid: {},
            loadingFids: {},
            statusRealized: STATUS_REALIZED,
            statusInProgress: STATUS_IN_PROGRESS,
            statusDefinitive: STATUS_DEFINITIVE,
            statusSuggestion: STATUS_SUGGESTION,
            chargingPointStatuses: [
                STATUS_REALIZED,
                STATUS_IN_PROGRESS,
                STATUS_DEFINITIVE,
                STATUS_SUGGESTION,
            ],
            tileDataContainerEl: null,
        }
    },
    computed: {
    ...mapGetters('tilesets', [
        'GetNeighborhoodPolygon',
    ]),
    ...mapGetters('access', [
        'getActiveMunicipality',
    ]),
    currentFid() {
        return this.fids && this.fids[0] ? this.fids[0] : null
    },
    },
    watch: {
        currentFid: {
            immediate: true,
            handler(fid) {
                if (fid) {
                    this.loadChargingPointsForStatuses(fid)
                }
            },
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.tileDataContainerEl = this.$el.closest('.TileData')
            if (this.tileDataContainerEl) {
                this.tileDataContainerEl.classList.add('TileData--wide')
            }
        })
    },
    beforeDestroy() {
        if (this.tileDataContainerEl) {
            this.tileDataContainerEl.classList.remove('TileData--wide')
            this.tileDataContainerEl = null
        }
    },
    methods: {
        ...mapActions('tilesets', [
            'fetchNeighborhoodPolygon',
        ]),
        toggleView() {
            this.simpleView = !this.simpleView
        },
        loadChargingPointsForStatuses(fid) {
            this.chargingPointStatuses.forEach((status) => {
                this.loadChargingPointsInNeighborhood(fid, status)
            })
        },
        getChargingPointsKey({ fid, status } = {}) {
            return `${fid || 'unknown'}:${status || 'all'}`
        },
        getChargingPointsCount({ fid = this.currentFid, status = STATUS_REALIZED } = {}) {
            if (!fid) return 0
            const key = this.getChargingPointsKey({ fid, status })
            const value = this.chargingPointsByFid[key]
            return value === undefined || value === null ? 0 : value
        },
        isChargingPointsLoadingForStatus(status) {
            if (!this.currentFid) return false
            const key = this.getChargingPointsKey({ fid: this.currentFid, status })
            if (this.loadingFids[key]) return true
            return !Object.prototype.hasOwnProperty.call(this.chargingPointsByFid, key)
        },
        isChargingPointsEmptyForStatus(status) {
            if (!this.currentFid) return false
            const key = this.getChargingPointsKey({ fid: this.currentFid, status })
            if (!Object.prototype.hasOwnProperty.call(this.chargingPointsByFid, key)) {
                return false
            }
            if (this.chargingPointsNotFoundByFid[key]) {
                return false
            }
            return this.chargingPointsByFid[key] === 0
        },
        generateFieldName(base, year) {
            return `${base}_${year}`
        },
        // publieke_laadpunten_bestelautos_M, semi_publiekelaadpunten_M
        // safe getter for raw numeric value from dataById for the first fid
        getRaw(field) {
            const fid = this.fids && this.fids[0]
            if (!fid || !this.dataById || !this.dataById[fid]) return 0
            const val = this.dataById[fid][field]
            const num = Number(val)
            return isNaN(num) ? 0 : num
        },

        laadpuntenBestelautos() {
            const year = this.year || (new Date()).getFullYear()
            const fieldName = this.generateFieldName('publieke_laadpunten_bestelautos_M', year)
            return this.getRaw(fieldName)
        },

        laadpuntenSemiPubliek() {
            const year = this.year || (new Date()).getFullYear()
            const fieldName = this.generateFieldName('semi_publiekelaadpunten_M', year)
            return this.getRaw(fieldName)
        },
        // only return totaal_laadpunten_<year>
        totalLaadpunten() {
            const year = this.year || (new Date()).getFullYear()
            const fieldName = this.generateFieldName('totaal_laadpunten', year)
            return this.getRaw(fieldName)
        },

        formatNumber(value, decimals = 1) {
            if (decimals === 0) return new Intl.NumberFormat().format(Math.round(value))
            return new Intl.NumberFormat(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value)
        },

        async loadChargingPointsInNeighborhood(fid, status = STATUS_REALIZED) {
            const key = this.getChargingPointsKey({ fid, status })
            if (!fid || this.loadingFids[key]) return

            if (this.chargingPointsByFid[key] !== undefined) return

            this.$set(this.loadingFids, key, true)

            try {
                const cachedNeighborhood = this.GetNeighborhoodPolygon(fid)
                const neighborhood = cachedNeighborhood || await this.fetchNeighborhoodPolygon({ fid })

                if (!neighborhood) {
                    this.$set(this.chargingPointsByFid, key, 0)
                    return
                }

                const geometry = neighborhood?.geometry
                const payloadCoordinates = buildPolygonPayloadCoordinates({ geometry })
                const response = await getChargingpointByPolygon(payloadCoordinates, { status })
                if (response?.status === 404) {
                    this.$set(this.chargingPointsByFid, key, 0)
                    this.$set(this.chargingPointsNotFoundByFid, key, true)
                    return
                }
                this.$set(this.chargingPointsNotFoundByFid, key, false)
                const responseData = response?.data ?? response
                const rawChargingpoints = Array.isArray(responseData) ? responseData
                    : Array.isArray(responseData?.chargingpoints) ? responseData.chargingpoints
                    : Array.isArray(responseData?.data) ? responseData.data
                    : null
                const chargingpoints = rawChargingpoints !== null
                    ? rawChargingpoints.filter(cp => cp.code === this.getActiveMunicipality)
                    : null
                const count = chargingpoints !== null
                    ? this.getOutletCount(chargingpoints)
                    : this.getChargingPointCount(responseData)
                this.$set(this.chargingPointsByFid, key, count)
            } catch (error) {
                console.log('Could not fetch charging points for neighborhood', error) // eslint-disable-line no-console
                this.$set(this.chargingPointsByFid, key, 0)
                this.$set(this.chargingPointsNotFoundByFid, key, false)
            } finally {
                this.$set(this.loadingFids, key, false)
            }
        },
        retryChargingPointsInNeighborhood(status = STATUS_REALIZED) {
            if (!this.currentFid) return
            const key = this.getChargingPointsKey({ fid: this.currentFid, status })
            this.$delete(this.chargingPointsByFid, key)
            this.$delete(this.chargingPointsNotFoundByFid, key)
            this.loadChargingPointsInNeighborhood(this.currentFid, status)
        },
        remainingChargingPoints() {
            const total = this.totalLaadpunten()
            const realized = this.getChargingPointsCount({ status: STATUS_REALIZED })
            const inProgress = this.getChargingPointsCount({ status: STATUS_IN_PROGRESS })
            const definitive = this.getChargingPointsCount({ status: STATUS_DEFINITIVE })
            const suggestion = this.getChargingPointsCount({ status: STATUS_SUGGESTION })
            const remaining = total - realized - inProgress - definitive - suggestion
            return remaining < 0 ? 0 : remaining
        },
        currentChargingPoints() {
            const realized = this.getChargingPointsCount({ status: STATUS_REALIZED })
            const inProgress = this.getChargingPointsCount({ status: STATUS_IN_PROGRESS })
            const definitive = this.getChargingPointsCount({ status: STATUS_DEFINITIVE })
            const suggestion = this.getChargingPointsCount({ status: STATUS_SUGGESTION })
            return realized + inProgress + definitive + suggestion
        },
        getOutletCount(chargingpoints) {
            return chargingpoints.reduce((sum, cp) => {
                const nroutlets = cp?.properties?.nroutlets
                return sum + (typeof nroutlets === 'number' ? nroutlets : 2)
            }, 0)
        },
        getChargingPointCount(response) {
            if (response === undefined || response === null) return 0
            if (typeof response === 'number') return response
            if (Array.isArray(response)) return response.length
            if (Array.isArray(response.chargingpoints)) return response.chargingpoints.length
            if (Array.isArray(response.data)) return response.data.length
            if (typeof response.count === 'number') return response.count
            if (typeof response.total === 'number') return response.total
            return 0
        },
    },
}
</script>

<style>
.currentView {
    color: var(--text-muted);
}

.otherView {
    cursor: pointer;

    &:hover {
        color: var(--cta);
    }
}

.TileData.TileData--wide {
    width: 520px;
    transform: translateX(520px);
}

.TileData.TileData--wide.open {
    transform: translateX(0);
}

.TileDataElaadCombination td {
    white-space: nowrap;
    vertical-align: middle;
}
</style>
